// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.featurelaunch.RentalManagerUserFeatureLaunchWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AcknowledgeFeatureLaunchNotificationsRequestDto, FeatureLaunchNotificationsResponseWebDto } from '../..';

interface NotificationsParams {
  bypassAcknowledged?: boolean;
}

export const RentalManagerUserFeatureLaunchWebApiHandler_acknowledge_Path =
  '/api/web/v1/users/featureLaunch/acknowledge';

/**
 * Acknowledge feature launch notifications for a user
 */
export const RentalManagerUserFeatureLaunchWebApiHandler_acknowledge = (
  postData: AcknowledgeFeatureLaunchNotificationsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AcknowledgeFeatureLaunchNotificationsRequestDto, void>(
    {
      endpoint: RentalManagerUserFeatureLaunchWebApiHandler_acknowledge_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserFeatureLaunchWebApiHandler_notifications_Path =
  '/api/web/v1/users/featureLaunch/notifications';

/**
 * Get list of feature launch notifications for a user
 */
export const RentalManagerUserFeatureLaunchWebApiHandler_notifications = (
  getParams: NotificationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<NotificationsParams, never, FeatureLaunchNotificationsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFeatureLaunchWebApiHandler_notifications_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
